module.exports = __webpack_public_path__ + "img/1212c_1.2cf5d374.jpg";